
import Recaptcha from './Recaptcha';
class FormValidator {

  constructor(form, id) {

    this.validateText = this.validateText.bind(this);
    this.validateTextArea = this.validateTextArea.bind(this);
    this.validateEmail = this.validateEmail.bind(this)
    this.validateSelect = this.validateSelect.bind(this)
    this.validatePhone = this.validatePhone.bind(this)
    this.validateFieldsetCheckbox = this.validateFieldsetCheckbox.bind(this)
    this.validateCheckbox = this.validateCheckbox.bind(this)
    this.checkValidation = this.checkValidation.bind(this);
    this.recaptchaCallback = this.recaptchaCallback.bind(this);
    this.expCallback = this.expCallback.bind(this);

    this.id = id;
    this.lang = document.querySelector('html').getAttribute('lang');
    this.form = form;
    this.textInputs = this.form.querySelectorAll('input[type="text"]');
    this.emailInputs = this.form.querySelectorAll('input[type="email"]');
    this.phoneInputs = this.form.querySelectorAll('input[type="tel"]');
    this.textAreas = this.form.querySelectorAll('textarea');
    this.selects = this.form.querySelectorAll('select');
    this.checkboxes = this.form.querySelectorAll('input[type="checkbox"]')
    this.fieldsetsCheckboxes = this.form.querySelectorAll("fieldset.webform-type-checkboxes");

    this.submitButtom = this.form.querySelector(".form-submit.button");


    this.allElements = [...this.textInputs, ...this.emailInputs, ...this.textAreas, ...this.selects,...this.fieldsetsCheckboxes, ...this.checkboxes, ...this.phoneInputs ]


    this.allElementsRequired = this.allElements.filter(element =>  element.classList.contains('required'));

    this.messages = {
      text: {
        emptyFR: 'Vous devez inscrire remplir ce champ.',
        emptyEN: 'This field is required.',
        patternFR: 'Les caractères spéciaux sont interdit',
        patternEN: 'Special characters are forbidden',
      },
      email: {
        emptyFR: 'Vous devez inscrire votre adresse courriel.',
        emptyEN: 'Your email address is required.',
        patternFR: 'Veuillez entrer une adresse courriel valide comprenant un @ et une extension.',
        patternEN: 'Make sure to enter a valid email address including @ and extension.',
      },
      phone: {
        emptyFR: 'Vous devez inscrire votre numéro de téléphone.',
        emptyEN: 'Your phone number is required.',
        patternFR: 'Inscrivez votre numéro sous le format 000 000-0000.',
        patternEN: 'Enter your number like so : 000 000-0000.',
      },
      textarea: {
        emptyFR: 'Veuillez nous indiquer comment nous pouvons vous aider.',
        emptyEN: 'Please, tell us how we can help you.',
        patternFR: 'Les caractères spéciaux sont interdit et votre message doit être en dessous de 600 caractères.',
        patternEN: 'Special characters are forbidden and you have a limit of 600 characters.',
      },
      choice: {
        emptyFR: 'Veuillez faire un choix.',
        emptyEN: 'Please, choose an option.',
      }
    };

    this.init();

    this.validatedItems = 0;

    // recaptcha hack
    window.validatedCaptcha = false;

    this.recaptchaContainer  = this.form.querySelector(".g-recaptcha-form")

    if(this.recaptchaContainer) {
      this.recaptcha = new Recaptcha(this.recaptchaContainer, `${this.id}-recaptcha`, this.recaptchaCallback, this.expCallback)
    }

  }


  init() {

    this.submitButtom.setAttribute('disabled', "disabled")

    this.textInputs.forEach(textInput => {
      textInput.addEventListener('change',this.validateText )
    });

    this.textAreas.forEach(textArea => {
      textArea.addEventListener('input',this.validateTextArea )
    });

    this.emailInputs.forEach(emailInput => {
      emailInput.addEventListener('change',this.validateEmail )
    });

    this.phoneInputs.forEach(phoneInput => {
      phoneInput.addEventListener('change',this.validatePhone )
    });

    this.selects.forEach(select => {
      select.addEventListener('change',this.validateSelect )
    });

    this.fieldsetsCheckboxes.forEach(fieldsetCheckboxe => {
      fieldsetCheckboxe.addEventListener('change',this.validateFieldsetCheckbox )
    });

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change',this.validateCheckbox )
    });


    if(this.recaptcha) {
      this.recaptcha.setAttribute('data-callback', 'recaptchaCallback');
    }
  }

  validateText(e) {
    const element = e.target;
    const closestParent = element.closest(".form-item")
    const regex = /^[0-9a-zA-ZÀ-ÿ( |\-|')]{1,100}$/;
    const textValue = regex.test(String(element.value).toLowerCase());
    let msg = "";

    // if filled
    if (element.value !== '') {
      element.classList.add('filled')
      // is pattern ok?
      if (textValue) {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
      else {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.text['pattern' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
    }
    // if empty
    else {
      element.classList.remove('filled')
      // but required
      if (element.classList.contains("required")) {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.text['empty' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
      else {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
    }

    closestParent.nextElementSibling.innerHTML = msg;
    this.checkValidation();
  }



  validateTextArea(e) {
    const element = e.target;
    const closestParent = element.closest(".form-item")
    const regex = /^[A-zÀ-ÿ0-9( |\-|'|\r|\n|\)|\(|)!?;:,\.]{1,599}$/;
    const textValue = regex.test(String(element.value).toLowerCase());
    let msg = "";

    // if filled
    if (element.value !== '') {
      element.classList.add('filled')
      // is pattern ok?
      if (textValue) {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
      else {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.textarea['pattern' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
    }
    // if empty
    else {
      element.classList.remove('filled')
      // but required
      if (element.classList.contains("required")) {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.textarea['empty' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
      else {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
    }

    closestParent.nextElementSibling.innerHTML = msg;
    this.checkValidation();
  }

  validateEmail(e) {
    const element = e.target;
    const closestParent = element.closest(".form-item")
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const textValue = regex.test(String(element.value).toLowerCase());
    let msg = "";

    // if filled
    if (element.value !== '') {
      element.classList.add('filled')
      // is pattern ok?
      if (textValue) {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
      else {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.email['pattern' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
    }
    // if empty
    else {
      element.classList.remove('filled')
      // but required
      if (element.classList.contains("required")) {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.email['empty' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
      else {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
    }

    closestParent.nextElementSibling.innerHTML = msg;
    this.checkValidation();
  }


  validatePhone(e) {
    const element = e.target;
    const closestParent = element.closest(".form-item")
    const regex = /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    const textValue = regex.test(String(element.value).toLowerCase());
    let msg = "";

    // if filled
    if (element.value !== '') {
      element.classList.add('filled')
      // is pattern ok?
      if (textValue) {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
      else {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.phone['pattern' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
    }
    // if empty
    else {
      element.classList.remove('filled')
      // but required
      if (element.classList.contains("required")) {
        element.classList.remove('validated')
        closestParent.classList.add('error')
        msg = this.messages.phone['empty' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
      else {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
    }

    closestParent.nextElementSibling.innerHTML = msg;
    this.checkValidation();
  }


  validateSelect(e) {
    const element = e.target;
    const closestParent = element.closest(".form-item")
    let msg = "";

    // if selected other than first
    if (element.value) {
      closestParent.classList.remove('error')
      element.classList.add('validated')
      this.validatedItems +=1;
    }
    else {
      // but required
      if (element.classList.contains("required")) {
        closestParent.classList.add('error')
        element.classList.remove('validated')
        msg = this.messages.choice['empty' + this.lang.toUpperCase()];
        this.validatedItems = Math.max(0, this.validatedItems - 1);
      }
      else {
        closestParent.classList.remove('error')
        element.classList.add('validated')
        msg = "";
        this.validatedItems += 1;
      }
    }

    closestParent.nextElementSibling.innerHTML = msg;
    this.checkValidation();
  }

  validateFieldsetCheckbox(e) {
    const element = e.target;
    const closestFieldSet = element.closest("fieldset")

    if(closestFieldSet.classList.contains("validated")) {
      closestFieldSet.classList.remove('error')
      this.validatedItems +=1;
    }
    else {
      closestFieldSet.classList.add('error')
      this.validatedItems = Math.max(0, this.validatedItems - 1);
    }
    this.checkValidation();
  }



  validateCheckbox(e) {
    const element = e.target;
    const closestParent = element.closest(".form-item")

    if(element.checked && element.classList.contains("required")) {
      element.classList.add("validated");
      closestParent.classList.remove('error')
      this.validatedItems +=1;
    }
    else {
      element.classList.remove("validated");
      closestParent.classList.add('error')
      this.validatedItems = Math.max(0, this.validatedItems - 1);
    }

    this.checkValidation();
  }


  recaptchaCallback() {
    const self = this;
    return new Promise(function (resolve, reject) {
      window.validatedCaptcha = true;
      self.checkValidation();
    });
  }

  expCallback() {

    window.validatedCaptcha = false;
    this.checkValidation();
  }


  checkValidation() {
    const lengthError = this.form.querySelectorAll(".error").length;
    const elementsRequiredValidated = this.allElementsRequired.filter(element =>  element.classList.contains('validated') )

    if(this.recaptcha) {
      if(elementsRequiredValidated.length ===  this.allElementsRequired.length &&  lengthError=== 0 && window.validatedCaptcha ) {
        this.submitButtom.removeAttribute('disabled')
      }else {
        this.submitButtom.setAttribute('disabled', "disabled")
      }
    }else {
      if(elementsRequiredValidated.length ===  this.allElementsRequired.length &&  lengthError=== 0 ) {
        this.submitButtom.removeAttribute('disabled')
      }else {
        this.submitButtom.setAttribute('disabled', "disabled")
      }
    }
  }
}

export default FormValidator;

